import { jsx } from "@emotion/react/jsx-runtime";
import _styled from "@emotion/styled/base";
import { useTheme } from "@emotion/react";
import useThemeProps from "./useThemeProps.mjs";
import Button from "./Button.mjs";
import renderIcon from "./renderIcon.mjs";
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const IconButtonRoot = /* @__PURE__ */_styled(Button, process.env.NODE_ENV === "production" ? {
  target: "epb0m7b0"
} : {
  target: "epb0m7b0",
  label: "IconButtonRoot"
})(process.env.NODE_ENV === "production" ? {
  name: "1cylnp7",
  styles: "display:inline-flex;place-content:center"
} : {
  name: "1cylnp7",
  styles: "display:inline-flex;place-content:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9qZWFuZnJlZHJpay9wcm9qZWN0cy93c3VpL3BhY2thZ2VzL2Jhc2Uvc3JjL0ljb25CdXR0b24uanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1xQyIsImZpbGUiOiIvVXNlcnMvamVhbmZyZWRyaWsvcHJvamVjdHMvd3N1aS9wYWNrYWdlcy9iYXNlL3NyYy9JY29uQnV0dG9uLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZVRoZW1lIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0XCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcbmltcG9ydCB1c2VUaGVtZVByb3BzIGZyb20gXCIuL3VzZVRoZW1lUHJvcHMuanN4XCI7XG5pbXBvcnQgQnV0dG9uIGZyb20gXCIuL0J1dHRvbi5qc3hcIjtcbmltcG9ydCByZW5kZXJJY29uIGZyb20gXCIuL3JlbmRlckljb24uanN4XCI7XG5cbmNvbnN0IEljb25CdXR0b25Sb290ID0gc3R5bGVkKEJ1dHRvbilgXG4gIGRpc3BsYXk6IGlubGluZS1mbGV4O1xuICBwbGFjZS1jb250ZW50OiBjZW50ZXI7XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBJY29uQnV0dG9uKHByb3BzKSB7XG4gIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBuby11bnVzZWQtdmFyc1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIHByb3BzID0gdXNlVGhlbWVQcm9wcyh7IHByb3BzLCBuYW1lOiBcIkljb25CdXR0b25cIiB9KTtcbiAgbGV0IHsgaWNvbiwgbmFtZSwgc2l6ZSwgc3JjLCBsYWJlbCwgLi4ucmVzdFByb3BzIH0gPSBwcm9wcztcbiAgcmV0dXJuIChcbiAgICA8SWNvbkJ1dHRvblJvb3QgYXJpYS1sYWJlbD17bGFiZWx9IHsuLi5yZXN0UHJvcHN9PlxuICAgICAge3JlbmRlckljb24oaWNvbiwgeyBuYW1lLCBzaXplLCBzcmMgfSl9XG4gICAgPC9JY29uQnV0dG9uUm9vdD5cbiAgKTtcbn1cbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
function IconButton(props) {
  useTheme();
  props = useThemeProps({
    props,
    name: "IconButton"
  });
  let {
    icon,
    name,
    size,
    src,
    label,
    ...restProps
  } = props;
  return /* @__PURE__ */jsx(IconButtonRoot, {
    "aria-label": label,
    ...restProps,
    children: renderIcon(icon, {
      name,
      size,
      src
    })
  });
}
export { IconButton as default };